import { usePage } from "@inertiajs/react";
import { Alert, Button, Stack } from "@mui/material";
import { FormEvent, useState } from "react";

import Input, { ChangeHandler, InputType } from "../../components/forms/Input";
import Container from "../../components/layout/Container";
import Main from "../../components/layout/Main";
import MetaData from "../../components/MetaData";
import Body from "../../components/theme/Body";
import Heading from "../../components/theme/Heading";
import useFetch from "../../hooks/useFetch";

const SEO_TITLE = "Contact";
const SEO_DESCRIPTION =
  "Wil je meer weten over Solidaritijd, wil je het toepassen voor jouw eigen demonstratie of heb je een andere vraag? Neem dan contact op.";

const Contact = () => {
  const { baseUrl } = usePage().props;
  const [post, { data, error, loading }] = useFetch(`${baseUrl}/contact`, {
    method: "POST",
  });
  const [values, setValues] = useState({ body: "", email: "" });
  const handleChange: ChangeHandler = (e) => {
    const { name, value } = e.target;
    setValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };
  const handleSubmit = (e: FormEvent) => {
    e?.preventDefault();
    post({
      contact: values,
    });
  };

  return (
    <div>
      <MetaData description={SEO_DESCRIPTION} title={SEO_TITLE} />
      <Main>
        <Heading marginBottom="0.5em" variant="h1">
          Contact
        </Heading>
        <Body marginBottom="1em" maxWidth={800}>
          Solidaritijd is bedacht om het makkelijker te maken om deel te nemen
          aan demonstraties. Het is een vrijwilligersinitiatief in samenwerking
          met DeGoedeZaak.
        </Body>
        <Body maxWidth={800}>
          Wil je meer weten over Solidaritijd, wil je het toepassen voor jouw
          eigen demonstratie, heb je een ander idee om de progressieve beweging
          te versterken of heb je een andere vraag? Vul dan onderstaand
          formulier in.
        </Body>
      </Main>
      <Container sx={{ marginTop: "1em" }}>
        <form onSubmit={handleSubmit}>
          <Stack
            spacing={1}
            sx={{ "& input, & textarea": { background: "white" } }}
          >
            <Input
              required
              label="E-mail"
              name="email"
              placeholder="email@voorbeeld.nl"
              type={InputType.Email}
              value={values.email}
              onChange={handleChange}
            />
            <Input
              required
              label="Bericht"
              name="body"
              placeholder="Bericht"
              type={InputType.TextArea}
              value={values.body}
              onChange={handleChange}
            />
          </Stack>
          {error && (
            <Alert severity="error" sx={{ marginTop: "1em" }}>
              {error}
            </Alert>
          )}
          {data ? (
            <Alert severity="success" sx={{ marginTop: "1em" }}>
              Bedankt voor je bericht!
            </Alert>
          ) : (
            <Stack direction="row" justifyContent="end">
              <Button
                loading={loading}
                sx={{ marginTop: "1em" }}
                type="submit"
                variant="contained"
              >
                Verstuur
              </Button>
            </Stack>
          )}
        </form>
      </Container>
    </div>
  );
};

export default Contact;
